import React, { useEffect, useState } from "react";
import { PromoBannerProps } from "web/react/components/promo-section/promo-section";
import { useDesktopBreakpoint } from "web/react/hooks/use-breakpoint/use-breakpoint";
import styles from "./sale-landing-page-promo-banner.module.css";

export function SaleLandingPagePromoBanner({
    title,
    url,
    desktop,
    mobile,
}: PromoBannerProps): JSX.Element {
    const isDesktop = useDesktopBreakpoint();
    const [moderatedImage, setModeratedImage] = useState(desktop);
    useEffect(() => {
        setModeratedImage(isDesktop ? desktop : mobile);
    }, [isDesktop]);

    return (
        <a href={url}>
            <div
                style={{
                    backgroundImage: `url(${moderatedImage})`,
                }}
                className={styles.headerWrap}
            >
                <h1 className={styles.title}>{title}</h1>
            </div>
        </a>
    );
}

export default SaleLandingPagePromoBanner;
